import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconReader = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_644_19820)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 2C7.105 2 8 2.895 8 4C8 5.105 7.105 6 6 6C4.895 6 4 5.105 4 4C4 2.895 4.895 2 6 2ZM2 10V9C2 7.67 4.665 7 6 7C7.335 7 10 7.67 10 9V10H2Z",
			fill: "#026BB6"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_644_19820",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white"
		})
	}) })]
});
export default SvgIconReader;
